/* Halftone hero + fade band — God's Work Clothing.
   The press and the fade ramp below are copied verbatim from the approved
   preview site by a build script. Do not hand-edit this file.

   Hero: the poster <img> has already painted by the time this runs; the canvas
   screens the clip live and cross-fades in over it, so nothing on the critical
   path waits for JS or video. Desktop only — on a phone the clip is the wrong
   shape, the per-frame resample costs battery, and the poster looks right.

   Fade: a static plate, drawn once. It is a canvas rather than an image because
   the strokes are vertical — stretching a pre-rendered one across a wide
   viewport would smear them. */
(() => {
  "use strict";
  const BIRD = {"cols":28,"aspect":1.625,"frames":[[null,null,[0.508,0.615],[0.508,0.631],[0.523,0.631],[0.523,0.631],[0.523,0.631],[0.523,0.923],[0.523,0.938],[0.523,0.969],[0.523,0.969],[0.523,0.954],[0.508,0.923],[0.508,0.908],[0.508,0.862],[0.492,0.969],[0.492,1.0],[0.492,0.954],[0.492,0.938],[0.477,0.862],[0.477,0.831],[0.477,0.769],[0.477,0.738],[0.477,0.692],[0.477,0.615],[0.492,0.6],[0.492,0.569],[0.508,0.569]],[null,null,[0.508,0.615],[0.508,0.631],[0.523,0.631],[0.523,0.631],[0.523,0.631],[0.523,0.923],[0.523,0.938],[0.523,0.969],[0.523,0.969],[0.523,0.954],[0.508,0.923],[0.508,0.908],[0.508,0.862],[0.492,0.969],[0.492,1.0],[0.492,0.954],[0.492,0.938],[0.477,0.862],[0.477,0.831],[0.477,0.769],[0.477,0.738],[0.477,0.692],[0.477,0.615],[0.492,0.6],[0.492,0.569],[0.508,0.569]],[[0.538,0.554],[0.523,0.6],[0.523,0.631],[0.523,0.646],[0.523,0.877],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.523,0.831],[0.523,0.815],[0.508,0.785],[0.508,0.769],[0.508,0.754],[0.492,0.754],[0.492,0.785],[0.492,0.785],[0.492,0.769],[0.492,0.723],[0.492,0.708],[0.492,0.662],[0.492,0.646],[0.492,0.631],[0.492,0.6],[0.492,0.585],[0.523,0.585],null],[[0.538,0.554],[0.523,0.6],[0.523,0.631],[0.523,0.646],[0.523,0.877],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.523,0.831],[0.523,0.815],[0.508,0.785],[0.508,0.769],[0.508,0.754],[0.492,0.754],[0.492,0.785],[0.492,0.785],[0.492,0.769],[0.492,0.723],[0.492,0.708],[0.492,0.662],[0.492,0.646],[0.492,0.631],[0.492,0.6],[0.492,0.585],[0.523,0.585],null],[[0.585,0.662],[0.585,0.677],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.354,0.692],[0.354,0.692],[0.369,0.692],[0.4,0.692],[0.415,0.738],[0.446,0.738],[0.4,0.738],[0.4,0.738],[0.4,0.738],[0.415,0.723],[0.462,0.723],[0.477,0.723],[0.523,0.723],[0.538,0.708],[0.554,0.708],[0.554,0.692],[0.554,0.692],[0.554,0.662],[0.569,0.646],[0.615,0.646],null],[[0.6,0.631],[0.585,0.662],[0.585,0.692],[0.585,0.708],[0.585,0.708],[0.077,0.708],[0.062,0.708],[0.031,0.692],[0.031,0.692],[0.046,0.692],[0.077,0.692],[0.092,0.692],[0.123,0.738],[0.062,0.738],[0.015,0.738],[0.0,0.738],[0.015,0.738],[0.062,0.723],[0.092,0.723],[0.154,0.723],[0.185,0.723],[0.246,0.708],[0.277,0.708],[0.308,0.692],[0.554,0.662],[0.554,0.646],[0.585,0.646],null],[[0.6,0.631],[0.585,0.662],[0.585,0.692],[0.585,0.708],[0.585,0.708],[0.077,0.708],[0.062,0.708],[0.031,0.692],[0.031,0.692],[0.046,0.692],[0.077,0.692],[0.092,0.692],[0.123,0.738],[0.062,0.738],[0.015,0.738],[0.0,0.738],[0.015,0.738],[0.062,0.723],[0.092,0.723],[0.154,0.723],[0.185,0.723],[0.246,0.708],[0.277,0.708],[0.308,0.692],[0.554,0.662],[0.554,0.646],[0.585,0.646],null],[null,null,[0.508,0.615],[0.508,0.631],[0.523,0.631],[0.523,0.631],[0.523,0.631],[0.523,0.923],[0.523,0.938],[0.523,0.969],[0.523,0.969],[0.523,0.954],[0.508,0.923],[0.508,0.908],[0.508,0.862],[0.492,0.969],[0.492,1.0],[0.492,0.954],[0.492,0.938],[0.477,0.862],[0.477,0.831],[0.477,0.769],[0.477,0.738],[0.477,0.692],[0.477,0.615],[0.492,0.6],[0.492,0.569],[0.508,0.569]],[null,null,[0.508,0.615],[0.508,0.631],[0.523,0.631],[0.523,0.631],[0.523,0.631],[0.523,0.923],[0.523,0.938],[0.523,0.969],[0.523,0.969],[0.523,0.954],[0.508,0.923],[0.508,0.908],[0.508,0.862],[0.492,0.969],[0.492,1.0],[0.492,0.954],[0.492,0.938],[0.477,0.862],[0.477,0.831],[0.477,0.769],[0.477,0.738],[0.477,0.692],[0.477,0.615],[0.492,0.6],[0.492,0.569],[0.508,0.569]],[[0.538,0.554],[0.523,0.6],[0.523,0.631],[0.523,0.646],[0.523,0.877],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.523,0.831],[0.523,0.815],[0.508,0.785],[0.508,0.769],[0.508,0.754],[0.492,0.754],[0.492,0.785],[0.492,0.785],[0.492,0.769],[0.492,0.723],[0.492,0.708],[0.492,0.662],[0.492,0.646],[0.492,0.631],[0.492,0.6],[0.492,0.585],[0.523,0.585],null],[[0.538,0.554],[0.523,0.6],[0.523,0.631],[0.523,0.646],[0.523,0.877],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.538,0.862],[0.523,0.831],[0.523,0.815],[0.508,0.785],[0.508,0.769],[0.508,0.754],[0.492,0.754],[0.492,0.785],[0.492,0.785],[0.492,0.769],[0.492,0.723],[0.492,0.708],[0.492,0.662],[0.492,0.646],[0.492,0.631],[0.492,0.6],[0.492,0.585],[0.523,0.585],null],[[0.585,0.662],[0.585,0.677],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.354,0.692],[0.354,0.692],[0.369,0.692],[0.4,0.692],[0.415,0.738],[0.446,0.738],[0.4,0.738],[0.4,0.738],[0.4,0.738],[0.415,0.723],[0.462,0.723],[0.477,0.723],[0.523,0.723],[0.538,0.708],[0.554,0.708],[0.554,0.692],[0.554,0.692],[0.554,0.662],[0.569,0.646],[0.615,0.646],null],[[0.585,0.662],[0.585,0.677],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.323,0.708],[0.354,0.692],[0.354,0.692],[0.369,0.692],[0.4,0.692],[0.415,0.738],[0.446,0.738],[0.4,0.738],[0.4,0.738],[0.4,0.738],[0.415,0.723],[0.462,0.723],[0.477,0.723],[0.523,0.723],[0.538,0.708],[0.554,0.708],[0.554,0.692],[0.554,0.692],[0.554,0.662],[0.569,0.646],[0.615,0.646],null],[[0.6,0.631],[0.585,0.662],[0.585,0.692],[0.585,0.708],[0.585,0.708],[0.077,0.708],[0.062,0.708],[0.031,0.692],[0.031,0.692],[0.046,0.692],[0.077,0.692],[0.092,0.692],[0.123,0.738],[0.062,0.738],[0.015,0.738],[0.0,0.738],[0.015,0.738],[0.062,0.723],[0.092,0.723],[0.154,0.723],[0.185,0.723],[0.246,0.708],[0.277,0.708],[0.308,0.692],[0.554,0.662],[0.554,0.646],[0.585,0.646],null],[[0.6,0.631],[0.585,0.662],[0.585,0.692],[0.585,0.708],[0.585,0.708],[0.077,0.708],[0.062,0.708],[0.031,0.692],[0.031,0.692],[0.046,0.692],[0.077,0.692],[0.092,0.692],[0.123,0.738],[0.062,0.738],[0.015,0.738],[0.0,0.738],[0.015,0.738],[0.062,0.723],[0.092,0.723],[0.154,0.723],[0.185,0.723],[0.246,0.708],[0.277,0.708],[0.308,0.692],[0.554,0.662],[0.554,0.646],[0.585,0.646],null],[[0.6,0.631],[0.585,0.662],[0.585,0.692],[0.585,0.708],[0.585,0.708],[0.077,0.708],[0.062,0.708],[0.031,0.692],[0.031,0.692],[0.046,0.692],[0.077,0.692],[0.092,0.708],[0.123,0.738],[0.062,0.738],[0.015,0.738],[0.0,0.738],[0.015,0.738],[0.062,0.723],[0.092,0.723],[0.154,0.723],[0.185,0.723],[0.246,0.708],[0.277,0.708],[0.308,0.692],[0.554,0.662],[0.554,0.646],[0.585,0.646],null],[[0.6,0.631],[0.585,0.662],[0.585,0.692],[0.585,0.708],[0.585,0.708],[0.077,0.708],[0.062,0.708],[0.031,0.692],[0.031,0.692],[0.046,0.692],[0.077,0.692],[0.092,0.708],[0.123,0.738],[0.062,0.738],[0.015,0.738],[0.0,0.738],[0.015,0.738],[0.062,0.723],[0.092,0.723],[0.154,0.723],[0.185,0.723],[0.246,0.708],[0.277,0.708],[0.308,0.692],[0.554,0.662],[0.554,0.646],[0.585,0.646],null],[[0.6,0.631],[0.585,0.662],[0.585,0.692],[0.585,0.708],[0.585,0.708],[0.077,0.708],[0.062,0.708],[0.031,0.692],[0.031,0.692],[0.046,0.692],[0.077,0.692],[0.092,0.708],[0.123,0.738],[0.062,0.738],[0.015,0.738],[0.0,0.738],[0.015,0.738],[0.062,0.723],[0.092,0.723],[0.154,0.723],[0.185,0.723],[0.246,0.708],[0.277,0.708],[0.308,0.692],[0.554,0.662],[0.554,0.646],[0.585,0.646],null],[[0.6,0.631],[0.585,0.662],[0.585,0.692],[0.585,0.708],[0.585,0.708],[0.077,0.708],[0.062,0.708],[0.031,0.692],[0.031,0.692],[0.046,0.692],[0.077,0.692],[0.092,0.708],[0.123,0.738],[0.062,0.738],[0.015,0.738],[0.0,0.738],[0.015,0.738],[0.062,0.723],[0.092,0.723],[0.154,0.723],[0.185,0.723],[0.246,0.708],[0.277,0.708],[0.308,0.692],[0.554,0.662],[0.554,0.646],[0.585,0.646],null]]};
  const reduced = matchMedia("(prefers-reduced-motion: reduce)").matches;
  const clamp = (v, a, b) => (v < a ? a : v > b ? b : v);

  function hash(n){ n=(n<<13)^n; return (((n*(n*n*15731+789221)+1376312589)&0x7fffffff)/0x7fffffff); }

  /* ---------------- the press ---------------- */
  function Press(canvas,cfg){
    const P=Object.assign({
      colW:3,barW:.9,rowH:1,dropout:0,
      black:0,white:.66,gamma:1,poster:.15,invert:0,
      drip:2.5,shimmer:0,speed:1,breath:0,
      birds:0,birdSize:22,birdSpeed:1,birdBand:.30,behind:.75,knockout:1,
      split:.47,spread:0,ease:2,
      ink:"#D9C4A3",ratio:null,fill:false,max:1700,dprMax:2,resampleMs:0
    },cfg);
    const ctx=canvas.getContext("2d",{alpha:true});
    const samp=document.createElement("canvas");
    const sctx=samp.getContext("2d",{willReadFrequently:true});
    const LUT=new Float32Array(1025);
    let W=0,H=0,dpr=1,src=null,cols=0,rows=0,lum=null,wArr=null,dirty=true,lastBuild=-1e9;
    const sw=()=>src?(src.videoWidth||src.width||0):0;
    const sh=()=>src?(src.videoHeight||src.height||0):0;
    const playing=()=>!!src&&src.tagName==="VIDEO"&&src.readyState>=2&&!src.paused&&!src.ended;

    function buildLUT(){
      const k=1+P.poster*26,sig=x=>1/(1+Math.exp(-k*(x-.5)));
      const lo=sig(0),hi=sig(1),span=Math.max(1e-4,P.white-P.black);
      for(let i=0;i<=1024;i++){
        let v=clamp((i/1024-P.black)/span,0,1); v=Math.pow(v,P.gamma);
        if(P.poster>0) v=clamp((sig(v)-lo)/(hi-lo),0,1);
        LUT[i]=P.invert?1-v:v;
      }
    }
    function resize(){
      dpr=Math.min(devicePixelRatio||1,P.dprMax);
      let cw,ch;
      if(P.fill){ cw=canvas.clientWidth; ch=canvas.clientHeight; }
      else{
        const box=canvas.parentElement;
        cw=Math.min(canvas.clientWidth||box.clientWidth,P.max);
        ch=cw*(P.ratio||(sw()&&sh()?sh()/sw():.5625));
        canvas.style.height=Math.round(ch)+"px";
      }
      if(!cw||!ch) return;
      W=Math.round(cw*dpr); H=Math.round(ch*dpr);
      canvas.width=W; canvas.height=H; dirty=true;
    }
    function build(){
      if(!src||!W) return;
      const cw=P.colW*dpr,rh=P.rowH*dpr;
      cols=Math.max(1,Math.floor(W/cw)); rows=Math.max(1,Math.ceil(H/rh)+2);
      samp.width=cols; samp.height=rows;
      sctx.setTransform(1,0,0,1,0,0); sctx.fillStyle="#000"; sctx.fillRect(0,0,cols,rows);
      const iw=sw(),ih=sh(); if(!iw||!ih) return;
      const s=Math.max(W/iw,H/ih),dw=iw*s*(cols/W),dh=ih*s*(rows/H);
      sctx.drawImage(src,(cols-dw)/2,(rows-dh)/2,dw,dh);
      const d=sctx.getImageData(0,0,cols,rows).data,need=cols*rows;
      if(!lum||lum.length!==need) lum=new Float32Array(need);
      if(!wArr||wArr.length!==rows) wArr=new Float32Array(rows);
      for(let i=0;i<need;i++){
        const a=d[i*4+3]/255;
        lum[i]=((0.2126*d[i*4]+0.7152*d[i*4+1]+0.0722*d[i*4+2])/255)*a;
      }
      dirty=false;
    }
    function emitBar(x,yTop,yBot,bw){
      const cw=P.colW*dpr,rh=P.rowH*dpr,c=(x/cw)|0;
      const ko=P.knockout>.5,off=c<0||c>=cols;
      if(off||(!ko&&P.behind<=0)){ if(!ko) ctx.rect(x,yTop,bw,yBot-yTop); return; }
      const hideAt=1-P.behind;
      const r0=Math.max(0,Math.floor(yTop/rh)),r1=Math.min(rows-1,Math.ceil(yBot/rh));
      let segTop=null;
      for(let r=r0;r<=r1;r++){
        const dense=LUT[(lum[r*cols+c]*1024)|0]>=hideAt;
        const show=ko?dense:!dense,yA=Math.max(yTop,r*rh);
        if(show){ if(segTop===null) segTop=yA; }
        else if(segTop!==null){ ctx.rect(x,segTop,bw,yA-segTop); segTop=null; }
      }
      if(segTop!==null&&yBot>segTop) ctx.rect(x,segTop,bw,yBot-segTop);
    }
    function addBirds(t){
      const cw=P.colW*dpr,n=Math.round(P.birds),NF=BIRD.frames.length;
      for(let i=0;i<n;i++){
        const dir=hash(i*71+3)>.5?1:-1,sc=.55+hash(i*457+9)*.95;
        const wb=P.birdSize*dpr*sc,hb=wb*BIRD.aspect;
        const sp=(.014+hash(i*911+3)*.028)*P.birdSpeed;
        let u=(hash(i*131+5)+t*sp*dir)%1.3; if(u<0)u+=1.3;
        const bx=(u-.15)*W,by=(P.birdBand+hash(i*77+1)*.30)*H+Math.sin(t*.35+i)*H*.012;
        const rate=9*P.birdSpeed*(.75+hash(i*613+11)*.5);
        const fi=(((Math.floor(t*rate+hash(i*337+13)*NF))%NF)+NF)%NF,fr=BIRD.frames[fi];
        const bcw=Math.min(cw,Math.max(2,wb/20)),bbw=Math.max(1,bcw*P.barW);
        const K=Math.max(3,Math.round(wb/bcw));
        for(let j=0;j<K;j++){
          const sj=dir>0?(K-1-j):j;
          const s0=(sj*BIRD.cols/K)|0,s1=Math.max(s0+1,((sj+1)*BIRD.cols/K)|0);
          let top=1,bot=0,any=false;
          for(let q=s0;q<Math.min(s1,BIRD.cols);q++){
            const cc=fr[q]; if(!cc) continue; any=true;
            if(cc[0]<top)top=cc[0]; if(cc[1]>bot)bot=cc[1];
          }
          if(!any) continue;
          const x=bx+j*bcw; if(x+bbw<0||x>W) continue;
          emitBar(x,by+top*hb,by+bot*hb,bbw);
        }
      }
    }
    function draw(t,prog){
      if(!W) return false;
      /* Re-sampling (drawImage + getImageData + the per-pixel luminance pass) is
         by far the most expensive work here, and it only yields new output when
         the VIDEO has a new frame. resampleMs decouples it from the repaint rate,
         so the ink and the birds still animate at the full refresh rate while the
         plate is rebuilt at roughly the clip's own frame rate. 0 = every frame.
         Throttling the whole repaint instead is what made the birds look choppy. */
      const ms=t*1000;
      if(dirty||(playing()&&ms-lastBuild>=P.resampleMs)){ build(); lastBuild=ms; }
      if(!lum) return false;
      const cw=P.colW*dpr,rh=P.rowH*dpr,bw=Math.max(1,cw*P.barW);
      const cs=Math.round(cols*P.split);
      const e=1-Math.pow(1-clamp(prog===undefined?1:prog,0,1),P.ease);
      const off=P.spread?P.spread*dpr*(1-e):0;
      ctx.clearRect(0,0,W,H);
      const br=reduced?0:P.breath,bph=Math.sin(t*.62);
      const dens=1+br*.18*bph,zoom=1+br*.022*(.5+.5*bph);
      ctx.save();
      if(zoom!==1){ ctx.translate(W/2,H/2); ctx.scale(zoom,zoom); ctx.translate(-W/2,-H/2); }
      ctx.fillStyle=P.ink; ctx.beginPath();
      const MINW=.6, shim=reduced?0:P.shimmer;
      for(let c=0;c<cols;c++){
        const x0=c*cw+(c<cs?-off:off);
        if(x0+cw<0||x0>W) continue;
        const bias=P.dropout?P.dropout*hash(c*374761+12345):0;
        const wob=shim>0?1-shim+shim*(.5+.5*Math.sin(t*P.speed*2+c*.07)):1;
        for(let r=0;r<rows;r++){
          const v=LUT[(lum[r*cols+c]*1024)|0]-bias;
          wArr[r]=v<=0?0:bw*(v>1?1:v)*dens;
        }
        let r=0;
        while(r<rows){
          if(wArr[r]<MINW){r++;continue;}
          const q=Math.round(wArr[r]*2)/2;
          let r1=r+1;
          while(r1<rows&&wArr[r1]>=MINW&&Math.round(wArr[r1]*2)/2===q) r1++;
          const y=r*rh; if(y>H) break;
          let h=(r1-r)*rh+.6;
          if(r1>=rows||wArr[r1]<MINW) h+=P.drip*rh*hash(c*6151+r*2749+7)**2*wob;
          ctx.rect(x0+(cw-q)/2,y,q,h);
          r=r1;
        }
      }
      ctx.fill();
      if(P.birds>0){
        const ko=P.knockout>.5;
        ctx.beginPath(); addBirds(reduced?0:t);
        if(ko) ctx.globalCompositeOperation="destination-out";
        ctx.fillStyle=ko?"#000":P.ink; ctx.fill();
        ctx.globalCompositeOperation="source-over";
      }
      ctx.restore();
      return true;
    }
    /* The LUT depends only on poster/black/white/gamma/invert, all fixed at
       construction — nothing mutates P afterwards. It used to be rebuilt inside
       draw(), i.e. 1025 Math.exp() per frame (~61k/sec at 60fps) to produce a
       byte-identical table every time. Build it once here instead. */
    buildLUT();
    return { resize, draw, setSource(s){src=s;resize();}, canvas };
  }

  /* ---------------- sources ---------------- */
  function toBlobURL(uri){
    if(!uri.startsWith("data:")) return uri;
    try{
      const c=uri.indexOf(","),head=uri.slice(5,c),mime=head.split(";")[0];
      const bin=atob(uri.slice(c+1)),u8=new Uint8Array(bin.length);
      for(let i=0;i<bin.length;i++) u8[i]=bin.charCodeAt(i);
      return URL.createObjectURL(new Blob([u8],{type:mime}));
    }catch(e){ return uri; }
  }

  function rnd(n){
    n=(n|0); n=(n<<13)^n;
    const m=(Math.imul(Math.imul(n,n),15731)+789221)|0;
    return ((Math.imul(n,m)+1376312589)&0x7fffffff)/0x7fffffff;
  }

  /* RA/RB are where the ramp starts and ends as a fraction of the band. RA sits
     above the band so the top is flooded solid; RB lands inside it so the last
     strays peter out before the edge instead of being cut off against the flat
     section. These two, plus white below, are the tuning — not the tone curve. */
  const RA=-.30, RB=.88, RSPAN=RB-RA;
  /* cols is the press's own column count. Painting the plate exactly 3 source px
     per column makes the press's downsample an exact 3:1 box — at any other
     ratio it averages across grain blocks and flattens them back to a uniform
     stroke, which is what "too perfect" looked like. */
  function ramp(w,h,cols,dir,seed){
    const c=document.createElement("canvas"), SX=3;
    const W=Math.max(64,cols*SX), H=Math.max(48,Math.round(W*h/w));
    c.width=W; c.height=H;
    const g=c.getContext("2d"),img=g.createImageData(W,H),d=img.data;
    const nc=cols+1, off=new Float32Array(nc);
    for(let i=0;i<nc;i++)
      off[i]=(rnd((i/5|0)*9781+seed*613+17)-.5)*.018      // clumps of strokes
            +(rnd(i*4409+seed*271+3)-.5)*.010;            // and stroke by stroke
    for(let y=0;y<H;y++){
      const v=dir>0?y/H:1-y/H, by=(y/46)|0;
      for(let x=0;x<W;x++){
        const i=(x/SX)|0;
        // left unclamped on purpose: past the end of the ramp it goes negative,
        // which is what lets the last specks die out instead of the grain
        // lifting them back over the threshold right at the band edge
        const raw=1-(v-(RA+off[i]))/RSPAN;
        // breakup is a midtone event: nil where the plate floods solid, nil
        // again once the ink is gone, so the tail thins out rather than
        // scattering loose specks across the last third of the band
        const t=raw>=1||raw<=0?0:(1-raw)*(raw*3.5<1?raw*3.5:1);
        const L=clamp(raw
          +(rnd(((x/(SX*9))|0)*613+((y/64)|0)*20011+seed*89)-.5)*.026*t   // blotches
          +(rnd(i*97+by*7919+seed*131)-.5)*.034*t          // dashes
          ,0,1)*255;
        const p=(y*W+x)<<2; d[p]=d[p+1]=d[p+2]=L; d[p+3]=255;
      }
    }
    g.putImageData(img,0,0);
    return c;
  }

  /* ---------------- hero ---------------- */
  function bootHero(root) {
    if (root.dataset.hhBooted) return;            // two sections load this file
    root.dataset.hhBooted = "1";
    const cv = root.querySelector(".hh-cv");
    const clip = root.getAttribute("data-clip");
    if (!cv || !clip) return;
    if (reduced) return;                                  // poster stands in

    /* Phones used to bail out here and keep the poster. They now run the press
       too, on a deliberately cheaper budget — see the press config, the paint
       throttle and the deferred fetch below. Two cases still keep the still:
       Save-Data (the clip is a discretionary 139KB) and genuinely low-core
       hardware, where a janky hero is worse than a sharp static one. */
    const phone = !matchMedia("(min-width: 750px)").matches;
    const conn = navigator.connection || navigator.webkitConnection || {};
    if (phone && (conn.saveData === true || (navigator.hardwareConcurrency || 8) <= 2)) return;

    const v = document.createElement("video");
    /* REQUIRED. The press calls getImageData() on its sampling canvas; drawing
       a cross-origin video into it without this taints the canvas and that read
       throws SecurityError, leaving the hero blank. Shopify's CDN sends
       access-control-allow-origin: *, so anonymous is honoured. */
    v.crossOrigin = "anonymous";
    v.src = clip;
    v.loop = true; v.muted = true; v.defaultMuted = true;
    v.playsInline = true; v.setAttribute("playsinline", "");
    /* iOS gates muted autoplay on the ATTRIBUTES, not just the properties. */
    v.autoplay = true; v.setAttribute("autoplay", ""); v.setAttribute("muted", "");
    v.preload = "auto";
    /* NOT left:-9999px. WebKit treats an off-screen video as not visible and will
       refuse to start — or quietly pause — muted autoplay to save power. That is
       exactly the "birds fly but the picture is frozen" symptom: the birds are
       drawn from the clock every frame, while the halftone only re-samples while
       the clip is genuinely playing. Park it inside the hero instead: 2px, fully
       transparent, beneath the canvas, but on-screen and non-zero. */
    v.style.cssText = "position:absolute;top:0;left:0;width:2px;height:2px;opacity:0;pointer-events:none;z-index:0";
    root.appendChild(v);

    /* white ink, not the site's cream — this hero runs black and white */
    const press = Press(cv, {colW:3,barW:.9,rowH:1,dropout:0,
    black:0,white:.66,gamma:1,poster:.15,invert:0,
    drip:2.5,shimmer:.25,speed:1.4,breath:0,
    /* Now a section setting rather than a constant — Noah called 8 too many on a
       real phone, and this is exactly the kind of visible-noise dial he has moved
       repeatedly, so it belongs in the editor rather than in here. Default 4. */
    birds: (function(){ const v = parseFloat(root.getAttribute("data-birds")); return isFinite(v) ? v : 4; })(),
    birdSize:22,birdSpeed:1,birdBand:.30,behind:.75,knockout:1,
    /* dprMax is the single biggest lever. The sampling grid is cols x rows and
       BOTH scale with dpr, so per-frame work grows with dpr^2 — 1.5 -> 1 on
       phones removes ~55% of it. At this stroke pitch the difference is not
       visible on a phone screen. Desktop keeps its approved 1.5. */
    /* The clip is 18fps, so rebuilding the plate every frame at 60fps repeated
       identical work ~3.3x. Phones rebuild at ~20fps and repaint at full rate. */
    resampleMs: phone ? 50 : 0,
    fill:true, dprMax: phone ? 1 : 1.5, ink: "#FFFFFF"});

    /* Repaint at the full refresh rate on every device — the birds and the ink
       are driven by the clock, so throttling the repaint made them stutter.
       The saving comes from `resampleMs` in the press config instead, which
       rebuilds the plate at roughly the clip's own 18fps. */
    const MIN_MS = 0;
    let onScreen = true, raf = 0, shown = false, last = -1e9;
    const paint = (now) => { raf = requestAnimationFrame(paint);
      if (now - last < MIN_MS) return;
      last = now;
      if (!press.draw(now / 1000, 1)) return;
      if (!shown) { shown = true; cv.classList.add("is-on"); root.classList.add("is-live"); } };
    const start = () => { if (!raf) raf = requestAnimationFrame(paint); };
    const stop  = () => { if (raf) { cancelAnimationFrame(raf); raf = 0; } };

    const resume = () => { if (onScreen && !document.hidden) { v.play().catch(() => {}); start(); } };
    const idle   = () => { v.pause(); stop(); };

    const begin = () => { press.setSource(v); resume(); };
    if (v.readyState >= 2) begin();
    else {
      v.addEventListener("loadeddata", begin, { once: true });
      v.addEventListener("canplay", begin, { once: true });
    }
    /* The poster is the LCP element. On a phone radio a 139KB clip fetched
       during load competes with it, so hold the fetch until the page is idle.
       Desktop starts immediately, exactly as before. */
    if (!phone) v.load();
    else {
      const idle = () => (window.requestIdleCallback
        ? requestIdleCallback(() => v.load(), { timeout: 2500 })
        : setTimeout(() => v.load(), 300));
      if (document.readyState === "complete") idle();
      else addEventListener("load", idle, { once: true });
    }

    /* stop the decode too, not just the drawing — an off-screen video still
       burns CPU decoding frames nobody sees */
    new IntersectionObserver((es) => {
      onScreen = es[0].isIntersecting;
      onScreen ? resume() : idle();
    }, { threshold: 0 }).observe(root);
    document.addEventListener("visibilitychange", () => (document.hidden ? idle() : resume()));

    /* iOS can still refuse that first play() — Low Power Mode blocks muted
       autoplay outright — and the rejection is swallowed by resume()'s .catch().
       A real user gesture is always allowed, so retry on the first touch, and
       keep a short watchdog until the clip is actually advancing. Both stop as
       soon as it plays; the watchdog gives up rather than polling forever. */
    const retry = () => { if (onScreen && !document.hidden && v.paused) v.play().catch(() => {}); };
    ["touchstart", "pointerdown", "click"].forEach((e) =>
      addEventListener(e, retry, { passive: true, capture: true }));
    let tries = 0, wd = setInterval(() => {
      if ((!v.paused && v.currentTime > 0.2) || ++tries > 25) { clearInterval(wd); return; }
      retry();
    }, 1200);

    let t = 0;
    addEventListener("resize", () => { clearTimeout(t); t = setTimeout(() => press.resize(), 140); });
  }

  /* ---------------- fade band ---------------- */
  function bootFade(root) {
    if (root.dataset.hfBooted) return;
    root.dataset.hfBooted = "1";
    const el = root.querySelector(".hf-cv");
    if (!el) return;
    const dir = +(root.getAttribute("data-dir") || 1);
    const seed = +(root.getAttribute("data-seed") || 1);
    const p = Press(el, {colW:3,barW:1,rowH:1,dropout:0,
                      black:0,white:.60,gamma:1,poster:.15,invert:0,
                      drip:2.5,shimmer:0,breath:0,birds:0,
                      fill:true,dprMax:1.5,ink:"#000"});
    const sync = () => {
      const w = el.clientWidth, h = el.clientHeight;
      if (!w || !h) return;
      const dpr = Math.min(devicePixelRatio || 1, 1.5);
      const cols = Math.max(1, Math.floor(Math.round(w * dpr) / (3 * dpr)));
      p.setSource(ramp(w, h, cols, dir, seed));
      p.draw(0, 1);
    };
    sync();
    /* the plate is static, so one draw is enough — but it can be measured at
       zero width while the section is still laying out, so try again on load */
    addEventListener("load", sync);
    let t = 0;
    addEventListener("resize", () => { clearTimeout(t); t = setTimeout(sync, 140); });
  }

  /* ---------------- photo plate ---------------- */
  /* One still photograph through the press. Unlike the hero there is no clip and
     no rAF loop: the source never changes, so it is built once per size. The
     fade that carries it into the footer is baked into the IMAGE, not laid over
     the canvas, so the press renders it as strokes thickening into a solid field
     rather than as flat colour washed over the top of them. */
  function bootPhoto(root) {
    if (root.dataset.hpBooted) return;
    root.dataset.hpBooted = "1";
    const el = root.querySelector(".hp-cv");
    const src = root.getAttribute("data-src");
    if (!el || !src) return;
    const num = (k, d) => { const v = parseFloat(root.getAttribute(k)); return isFinite(v) ? v : d; };
    /* 🚨 Do NOT copy the hero's phone budget here. The hero caps dpr at 1 and
       thins its grid because it REPAINTS ~60x a second; this plate draws ONCE, so
       the same caps buy nothing and cost everything.

       Two separate things go wrong at 390px wide, and they compound:
       - cols is `cssWidth / colW`, INDEPENDENT of dpr — 480 columns at 1440, but
         only 130 at 390 with a 3px pitch. The same photograph gets 3.7x less
         detail, so the subject dissolves into stripes.
       - dprMax 1 then renders those few strokes into a 390px backing store that
         the browser upscales 3x on a retina phone, so every stroke edge is
         smeared across 3 device pixels.
       Phones therefore get a FINER pitch and a HIGHER dpr than desktop, which is
       backwards from the hero and correct for a still. The one-off cost is a
       195 x ~450 sample grid — trivial, and it happens once. */
    const phone = !matchMedia("(min-width: 750px)").matches;
    /* The hero's ink/ground pair (white on black) is what keeps a photograph
       POSITIVE — the press inks the BRIGHT end of the range, so black ink on a
       white ground renders a negative. The tone curve, though, is the preview
       site's closer, not the hero's: this frame's sea is far brighter than the
       hero clip, and the hero's white point of .66 saturates all of it into one
       flat field. .95 keeps the sunset's gradation.

       barW defaults to 1 here, not the hero's .9, because this plate has to JOIN
       the sections either side of it. At .9 every stroke leaves a 10% gap, so a
       fully-inked band is 90% covered rather than solid, and the join reads as a
       striped seam against the flat colour next to it. At 1 the strokes touch
       and a saturated band becomes a continuous field. */
    const p = Press(el, {
      colW: phone ? num("data-colw-mobile", 2) : num("data-colw", 3),
      barW: num("data-barw", 1), rowH: 1, dropout: 0,
      black: num("data-black", .14), white: num("data-white", .95),
      gamma: 1.05, poster: num("data-poster", .2), invert: 0,
      drip: 2.5, shimmer: 0, breath: 0, birds: 0,
      ratio: phone ? num("data-ratio-mobile", .9) : num("data-ratio-desktop", .55),
      max: 2200, dprMax: phone ? 2.5 : 1.5,
      ink: root.getAttribute("data-ink") || "#FFFFFF"
    });
    let ready = false;
    const img = new Image();
    img.onload = () => { ready = true; p.setSource(img); p.draw(0, 1); };
    img.src = src;
    /* the section can be measured at zero width while the page is still laying
       out, exactly as the fade band can — redraw once everything has settled */
    addEventListener("load", () => { if (ready) { p.resize(); p.draw(0, 1); } });
    let t = 0;
    addEventListener("resize", () => {
      clearTimeout(t);
      t = setTimeout(() => { if (ready) { p.resize(); p.draw(0, 1); } }, 140);
    });
  }

  /* ---------------- background plate ---------------- */
  /* ONE plate spanning several sections, not one per section. The layer is
     appended to <body> and positioned in page coordinates, because the sections
     it covers are siblings — nothing in the theme wraps them, so there is no
     shared positioned ancestor to hang an absolute child on.

     z-index -1 puts it under in-flow content but over the page background, so
     the product cards stay on top. That only reads if the sections it spans are
     transparent — Dawn paints them with a colour scheme, so we clear that here
     rather than guessing their generated section ids in CSS. */
  function bootPlate(cfgEl) {
    /* Guard hard: a second pass re-reads a DOM the first pass already reordered,
       so it picks the wrong row and undoes the move — and stacks a second plate
       layer on top. */
    if (cfgEl.dataset.hpBooted) return;
    cfgEl.dataset.hpBooted = "1";
    const srcA = cfgEl.getAttribute("data-src-a");
    const srcB = cfgEl.getAttribute("data-src-b");
    const span = Math.max(1, +(cfgEl.getAttribute("data-span") || 3));
    const angle = +(cfgEl.getAttribute("data-angle") || 40);
    const size = +(cfgEl.getAttribute("data-size") || 0.8);
    const opacity = +(cfgEl.getAttribute("data-opacity") || 0.1);
    if (!srcA || !srcB) return;

    const own = cfgEl.closest(".shopify-section") || cfgEl;
    const targets = [];
    for (let n = own.nextElementSibling; n && targets.length < span; n = n.nextElementSibling) {
      if (n.classList.contains("shopify-section")) targets.push(n);
    }
    if (!targets.length) return;

    const layer = document.createElement("div");
    layer.style.cssText = "position:absolute;left:0;right:0;z-index:-1;pointer-events:none;overflow:hidden";
    layer.style.opacity = opacity;
    const cv = document.createElement("canvas");
    cv.style.cssText = "width:100%;height:100%;display:block";
    layer.appendChild(cv);
    document.body.appendChild(layer);

    const clearBg = (el) => {
      el.style.background = "transparent";
      el.querySelectorAll(".gradient, [class*='color-background'], [class*='color-scheme']")
        .forEach((n) => { n.style.background = "transparent"; });
    };
    targets.forEach(clearBg);

    const press = Press(cv, {colW:4,barW:.9,rowH:1,dropout:0,
                            black:0,white:.62,gamma:1,poster:.12,invert:0,
                            drip:2,fill:true,dprMax:1.25,ink:"#171310"});

    const imgA = new Image(), imgB = new Image();
    let left = 2;
    const onReady = () => { if (--left === 0) sync(); };
    imgA.onload = onReady; imgB.onload = onReady;
    imgA.src = srcA; imgB.src = srcB;

    /* Two separate hands in opposite corners, not one joined picture.

       Each is anchored by its ARM END rather than its centre: the source is a
       crop, so the forearm stops in a straight cut, and parking that cut just
       outside the corner is what keeps it off screen. Adam's arm leaves the
       image on the left and his fingers point right; God's leaves on the right
       and points left — so the same rotation sends one up-right out of the
       bottom-left corner and the other down-left out of the top-right. */
    function plate(w, h, midTop, midBot) {
      const W = Math.min(1400, Math.max(320, Math.round(w)));
      const H = Math.max(64, Math.round(W * h / w));
      const c2 = document.createElement("canvas");
      c2.width = W; c2.height = H;
      const g = c2.getContext("2d");
      g.fillStyle = "#000"; g.fillRect(0, 0, W, H);

      /* Each arm enters from a side edge at the vertical MIDDLE of its row —
         God's at the first row, Adam's at the last — rather than at the extreme
         top and bottom corners, so the hands sit level with product rows instead
         of tucked into the corners of the whole span. */
      const yTop = midTop * H / h, yBot = midBot * H / h;

      /* Aim each hand at the other. God's source points -x and Adam's +x, so
         the SAME rotation turns both toward the line joining their two anchors —
         which is what makes the fingers face each other. Derived, not set: the
         gap between the rows changes with product count and viewport. */
      const auto = Math.atan2(yBot - yTop, W) * 180 / Math.PI;
      const th = -(angle > 0 ? angle : auto) * Math.PI / 180;
      const c = Math.cos(th), s = Math.sin(th);

      /* Each source carries a replicated tail on its arm side worth 30% of its
         width; anchoring at that same fraction puts the WHOLE real forearm
         inside the region and sends only the synthetic tail (and its cut) off
         screen. So each hand reaches (1 - BURY) of its width past its anchor. */
      const BURY = 0.30, REACH = 1 - BURY;

      /* One scale for both, not one per image: the two crops are different
         widths (God needs more room for his arm), so sizing each by its own
         width would draw the hands at different sizes.

         Then CLAMP it so the two can never collide. A wider, shorter span pulls
         the anchors closer together, and at a fixed size the fingers start
         overlapping — which is what happened on a laptop while mobile looked
         fine. Cap the scale at whatever keeps their combined reach inside the
         gap between the anchors, with 8% to spare. */
      const span = Math.hypot(W, yBot - yTop);
      const maxUnit = span * 0.92 /
                      ((imgA.naturalWidth + imgB.naturalWidth) * REACH);
      const unit = Math.min(size * W / 600, maxUnit);
      const put = (img, ax, ay) => {
        const w2 = img.naturalWidth * unit, h2 = img.naturalHeight * unit;
        // ax,ay is where the ARM END sits (see BURY above)
        const half = w2 * (0.5 - BURY);
        g.save();
        g.translate(ax + (ax > W / 2 ? -half * c : half * c),
                    ay + (ax > W / 2 ? -half * s : half * s));
        g.rotate(th);
        g.drawImage(img, -w2 / 2, -h2 / 2, w2, h2);
        g.restore();
      };
      put(imgB, W, yTop);   // God: in from the right, level with the first row
      put(imgA, 0, yBot);   // Adam: in from the left, level with the last row
      return c2;
    }

    function sync() {
      if (left > 0) return;
      /* min/max across the group, and remember the FIRST and LAST rows in visual
         order — the array order stops matching the DOM once mobile reorders. */
      let t0 = Infinity, b1 = -Infinity, firstMid = 0, lastMid = 0;
      targets.forEach((el) => {
        const r = el.getBoundingClientRect();
        const tp = r.top + scrollY, bt = r.bottom + scrollY;
        if (tp < t0) { t0 = tp; firstMid = (tp + bt) / 2; }
        if (bt > b1) { b1 = bt; lastMid = (tp + bt) / 2; }
      });
      const top = t0, h = b1 - t0;
      const w = document.documentElement.clientWidth;
      if (!w || h < 40) return;
      layer.style.top = top + "px";
      layer.style.height = h + "px";
      press.setSource(plate(w, h, firstMid - top, lastMid - top));
      press.draw(0, 1);
    }

    /* Move one row to the end of the group on narrow screens. Done by moving the
       node rather than with flex `order`, because the rows are siblings of every
       other section in <main> — making that a flex container to reorder three of
       its children would reflow the whole page. A comment marks the original
       slot so desktop can put it back exactly. */
    const mobileLast = +(cfgEl.getAttribute("data-mobile-last") || 0);
    const mq = matchMedia("(max-width: 749px)");
    let slot = null;
    function reorder() {
      const i = mobileLast - 1;
      if (i < 0 || i >= targets.length) return;
      const el = targets[i];
      if (mq.matches) {
        if (!slot) { slot = document.createComment("halftone-row-slot"); el.before(slot); }
        /* targets keeps its original document order and is never mutated, so the
           row to sit behind is simply the last of the others */
        const others = targets.filter((x) => x !== el);
        const last = others[others.length - 1];
        if (last && last.nextElementSibling !== el) last.after(el);
      } else if (slot) {
        slot.after(el); slot.remove(); slot = null;
      }
    }

    addEventListener("load", sync);
    let t = 0;
    /* reorder from the resize event too, not just the media-query change event:
       the change event did not fire on a driven window resize, and a phone
       rotating across the breakpoint is a real case. reorder() is idempotent. */
    addEventListener("resize", () => {
      clearTimeout(t); t = setTimeout(() => { reorder(); sync(); }, 160);
    });
    /* the rows below it load product images lazily, so the span keeps growing
       after first paint — re-measure when they settle */
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(() => { clearTimeout(t); t = setTimeout(sync, 160); });
      targets.forEach((el) => ro.observe(el));
    }
    reorder();
    const onMq = () => { reorder(); clearTimeout(t); t = setTimeout(sync, 160); };
    mq.addEventListener ? mq.addEventListener("change", onMq) : mq.addListener(onMq);
  }

  /* ---------------- hero button ---------------- */
  /* Animated by hand rather than with scrollIntoView({behavior:"smooth"}).
     Native smooth scrolling is silently a no-op in some contexts — it did
     nothing here while behavior:"auto" worked — and a Shop Now button that
     quietly fails to move the page is worse than one that jumps. */
  function glide(el) {
    const from = scrollY, to = el.getBoundingClientRect().top + scrollY, d = to - from;
    /* document.hidden also means requestAnimationFrame is parked, so the
       animation would never advance and the click would appear to do nothing */
    if (reduced || document.hidden || Math.abs(d) < 4) { scrollTo(0, to); return; }
    const dur = Math.min(900, Math.max(380, Math.abs(d) * 0.5)), t0 = performance.now();
    const ease = (p) => (p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2);
    const step = (now) => {
      const p = Math.min(1, (now - t0) / dur);
      scrollTo(0, from + d * ease(p));
      if (p < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  }

  /* The link already points at the catalogue so it works with no JS at all;
     here we upgrade it to a scroll down to the first product row on the page. */
  function bindScroll() {
    document.querySelectorAll("[data-hh-scroll]").forEach((a) => {
      if (a.dataset.hhBound) return;
      a.dataset.hhBound = "1";
      a.addEventListener("click", (e) => {
        const card = document.querySelector(".product-card-wrapper, .card-wrapper");
        const target = card && card.closest(".shopify-section");
        if (!target) return;                       // no product row here — follow the href
        e.preventDefault();
        glide(target);
      });
    });
  }

  const init = () => {
    bindScroll();
    document.querySelectorAll("[data-halftone-hero]").forEach(bootHero);
    document.querySelectorAll("[data-halftone-fade]").forEach(bootFade);
    document.querySelectorAll("[data-halftone-plate]").forEach(bootPlate);
    document.querySelectorAll("[data-halftone-photo]").forEach(bootPhoto);
  };
  if (document.readyState === "loading") addEventListener("DOMContentLoaded", init);
  else init();
  /* re-boot when the theme editor swaps a section back in */
  document.addEventListener("shopify:section:load", (e) => {
    bindScroll();
    const h = e.target.querySelector("[data-halftone-hero]");
    if (h) bootHero(h);
    const f = e.target.querySelector("[data-halftone-fade]");
    if (f) bootFade(f);
    const p = e.target.querySelector("[data-halftone-plate]");
    if (p) bootPlate(p);
    const ph = e.target.querySelector("[data-halftone-photo]");
    if (ph) bootPhoto(ph);
  });
})();
